// extracted by mini-css-extract-plugin
export default {"orderLandingPoint":"styles_orderLandingPoint__YHV+Z","coordinates":"styles_coordinates__Uw19U"};